// @ts-strict-ignore
import { PropertyVO } from '@project/components/article/model/vo/property.vo';
import { BasePropertyOperation } from './base-property-operation';
import { IOperation } from '@shared/undo/operation/i-operation';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ProjectModel } from '@project/model/project.model';
import { AdminService } from '../services/admin.service';
import { ConnectionUtils } from '@3d-scene/model3d/util/connection-utils';

export class AddConnectionPropertyOperation extends BasePropertyOperation implements IOperation {
  constructor(
    property: PropertyVO,
    private _connectionName: string,
    private _article: ArticleVO,
    propertyType: string,
    projectModel: ProjectModel,
    connectionUtils: ConnectionUtils,
    adminService: AdminService,
  ) {
    super(property, propertyType, projectModel, connectionUtils, adminService);
  }

  public getQualifiedClassName(): string {
    return 'AddConnectionPropertyOperation';
  }

  public async performRedo(): Promise<void> {
    this.addConnectionPropertyToConnection(this._connectionName, this._article);
  }

  public async performUndo(): Promise<void> {
    this.removeConnectionPropertyFromConnection(this._connectionName, this._article);
  }

  public getOperationDescription(): string {
    return 'addConnectionPropertyOperation.description';
  }
}
